import { render, staticRenderFns } from "./RingBarTabs.vue?vue&type=template&id=310eb800&scoped=true"
import script from "./RingBarTabs.vue?vue&type=script&lang=js"
export * from "./RingBarTabs.vue?vue&type=script&lang=js"
import style0 from "./RingBarTabs.vue?vue&type=style&index=0&id=310eb800&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310eb800",
  null
  
)

export default component.exports